import { FlyupEditingModal } from "shared/components";
import { useTagMergeFlyup, UseTagMergeFlyupProps } from "./useTagMergeFlyup";
import { Trans, useTranslation } from "react-i18next";
import { UnionHorizAlt } from "iconoir-react";
import { Select, Text } from "@ttc3k/trekker";
import { Flex, styled } from "styled-system/jsx";
import { getMultilingualString } from "shared/utils";

export const TagMergeFlyup = ({
  tag,
  allTagGroupsWithTags,
  isOpen,
  onClose,
  onTagMergeCompleted,
  refetchQueries,
}: UseTagMergeFlyupProps) => {
  const { t } = useTranslation("adminland", {
    keyPrefix: "PAGE.TAG_MANAGER.FLYOUTS.TAG_DETAILS.TAG_MERGE_MODAL",
  });

  const {
    collectionOfAvailableTags,
    mergeInto,
    setMergeInto,
    mergeTagLoading,
    onMergeTag,
  } = useTagMergeFlyup({
    tag,
    isOpen,
    onClose,
    onTagMergeCompleted,
    allTagGroupsWithTags,
    refetchQueries,
  });

  return (
    <FlyupEditingModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("TITLE")}
      HeaderIcon={UnionHorizAlt}
      headerIconProps={{ size: "lg" }}
      cancelButtonProps={{
        mode: "light",
        children: t("CTA_BUTTONS.CANCEL"),
        onClick: onClose,
        type: "button",
      }}
      saveButtonProps={{
        children: t("CTA_BUTTONS.MERGE"),
        visual: "accent.blue",
        disabled: !mergeInto,
        isLoading: mergeTagLoading,
        onClick: onMergeTag,
        type: "button",
      }}
    >
      <Flex flexDir="column" gap="200">
        <Text>
          <Trans
            i18nKey={`adminland:PAGE.TAG_MANAGER.FLYOUTS.TAG_DETAILS.TAG_MERGE_MODAL.DESCRIPTION_1`}
            components={{
              span: <styled.span fontWeight="bold" />,
            }}
            values={{
              tag: getMultilingualString(tag?.name ?? {}),
            }}
          />
        </Text>
        <Text>
          <Trans
            i18nKey={`adminland:PAGE.TAG_MANAGER.FLYOUTS.TAG_DETAILS.TAG_MERGE_MODAL.DESCRIPTION_2`}
            components={{
              span: <styled.span fontWeight="bold" />,
            }}
            values={{
              tag: getMultilingualString(tag?.name ?? {}),
            }}
          />
        </Text>
        <Select.Root
          label={t("MERGE_INTO")}
          collection={collectionOfAvailableTags}
          value={[mergeInto ?? ""]}
          onValueChange={({ value }) => setMergeInto(value[0])}
        >
          {collectionOfAvailableTags.group().map(([group, items]) => (
            <Select.ItemGroup key={group}>
              <Select.ItemGroupLabel>
                {items[0].groupLabel}
              </Select.ItemGroupLabel>
              {items.map(item => (
                <Select.Item key={item.value} item={item} paddingLeft={"300"} />
              ))}
            </Select.ItemGroup>
          ))}
        </Select.Root>
      </Flex>
    </FlyupEditingModal>
  );
};
